<template>
  <div class="flex">
    <div :class="`tracking_status tracking_status_${isDelivered ? 'deliverd' : ''}`">
      {{
        !isDelivered ? $t("trackPay.tabs.tracking") : $t("trackPay.trackStatus.delivered")
      }}
    </div>
  </div>
</template>

<script>
// enumDef
import { enumDef } from "@/common/enumDefs";
export default {
  data() {
    return {};
  },

  computed: {
    status() {
      return this.params.data.status;
    },
    isDelivered() {
      return this.status === enumDef.trackPayStats.Arrived;
    },
  },
};
</script>
<style lang="scss" scoped>
.tracking_status {
  border-left: 5px solid #0071eb;
  color: #0071eb;
  width: 100px;
  background-color: rgba($color: #0071eb, $alpha: 0.1);
  display: inline-block;
  text-align: center;
  font-weight: bold;
  &.tracking_status_deliverd {
    border-left: 5px solid #58b71d;
    color: #58b71d;
    background-color: rgba($color: #58b71d, $alpha: 0.1);
  }
}
</style>
